import styled, { to } from 'theme';

export const StatusIconWrapper = styled.div``;

const StatusIcon = styled.div`
  height: 1.5rem;
  width: 1.5rem;

  ${to('md')} {
    margin-top: 0.625rem;
    margin-bottom: 1.875rem;
  }
`;

export const StatusSuccessIcon = styled(StatusIcon)`
  background: url(${props => props.theme.variables.icons.svg.successIcon});
`;

export const StatusFailIcon = styled(StatusIcon)`
  background: url(${props => props.theme.variables.icons.svg.failIcon});
`;
